import { createAction } from '@ngrx/store';

export const addDirectDebitAttempt = createAction(
  '[Complete Order] Add Direct Debit Attempt'
);

export const resetDirectDebitAttempts = createAction(
  '[Complete Order] Reset Direct Debit Attempts'
);

export type DirectDebitAttemptActions =
  | typeof addDirectDebitAttempt
  | typeof resetDirectDebitAttempts;
